import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  outer: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "&>img": {
      display: "block",
      width: "214px",
      height: "74px",
      margin: `${theme.spacing(2)}px`
    },
    "& div": {
      maxWidth: "240px"
    },
    "& button": {
      display: "block",
      marginLeft: "auto"
    }
  },
  loginFailed: {
      margin: `${theme.spacing(1)}px`,
      color: theme.palette.error.dark
  }
}));
